import { Fab } from "@rmwc/fab";
import { List } from "@rmwc/list";
import { Snackbar, SnackbarAction } from "@rmwc/snackbar";
import { TextField } from "@rmwc/textfield";
import "@rmwc/textfield/styles";
import { RESSOURCE_DISTRIBUTION_UTILISATEUR, RESSOURCE_PRE_ACHATS, RESSOURCE_SERVICES, RESSOURCE_TARIFS, RESSOURCE_TERMINAL_ETAT, RESSOURCE_ZONE } from "Achat/API/AchatApi";
import { MODES, PAYZEN, PAYZEN_BORNE, PAYZEN_TPE, SERVICES_TYPES, TPE, TYPE_ACHAT, UNITE_TYPES } from "Achat/Constants";
import { setAchat } from "Achat/Store/actions";
import { selectToken, selectTokenValue, selectUserEmail, selectUserPlate } from "App/Authentification/Store/selectors";
import { URL_BASE } from "App/Constants";
import { setBackVisible } from "App/Header/Store/actions";
import { Modale } from "App/Modale/Components/Modale";
import { showError } from "App/Toast/Toast";
import _ from "lodash";
import moment from "moment";
import { PaymentForm } from "PaymentForm/Components/PaymentForm";
import { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { selectDataReferentielServiceTypes, selectDataReferentielUniteTypes } from "Referentiel/Store/selectors";
import { createResource, getResource, GET, POST } from "Request/Components/RequestUtils";
import { GET_LIST, GET_LIST_WITH_PARAMS, GET_SINGLE, useJsonRequest } from "Request/Components/useJsonRequest";
import { selectDataResourceReceived, selectDataResourceUpdated } from "Request/Store/selectors";
import { ConfirmModal } from "Shared/ConfirmModal";
import { TicketClientModale } from "TicketClient/Components/TicketClientModale";
import "./Achat.css";
import { AchatList } from "./AchatList";
import { DescriptifBorne } from "./DescriptifBorne";
import { ModaleAttentePaiementTPE } from "./ModaleAttentePaiementTPE";
import { ModaleInfosTranches } from "./ModaleInfosTranches";
import { ModaleTypePaiement } from "./ModaleTypePaiement";
import { getCurrentTranche, getTranches } from "./Utils/achatUtils";
import i18n from "i18next";
import { getNormalizedLanguageCode } from "utils/languageUtils";

// #region CONSTANTES
// Status du paiement
const PAID = "00";
// AYB 2026.02.19 statuts Payzen pour le polling après fermeture modale (alignés PaymentForm)
const PAYZEN_VALID_STATUS = ["AUTHORISED", "CAPTURED"];
const PAYZEN_REFUSED_STATUSES = ["REFUSED", "CANCELLED", "ABORTED", "EXPIRED"];
const PENDING_ACHAT_KEY = "pendingAchat";
const PENDING_STAGE_KEY = "pendingAchatStage";
// #endregion

// #region FONCTION COMPOSANT
/**
* Composant permettant d'afficher la liste pour achat sur une borne
* @class
* @category Achat
*/
function Achat() {
  // #region INITIALISATION
  // Récupération des props
  const history = useHistory();
  const location = useLocation();
  const borne = location.state.borne;
  const [isRachat, setIsRachat] = useState({
    rachat: location.state.rachat,
    rachatIdService: location.state.rachatIdService
  });

  const token = useSelector((state) => selectToken(state));
  const tokenValue = useSelector((state) => selectTokenValue(state));
  const serviceTypes = useSelector((state) => selectDataReferentielServiceTypes(state));
  const uniteTypes = useSelector((state) => selectDataReferentielUniteTypes(state));
  const userEmail = useSelector((state) => selectUserEmail(state));
  const userPlate = useSelector((state) => selectUserPlate(state));

  // Initialisation du state
  const [currentAchat, setCurrentAchat] = useState(null); // Achat pour le ticket PAYZEN
  const [data, setData] = useState(); // Données de l'écran
  const [dataServices, setDataServices] = useState(null); // Données des services
  const [dataTarifs, setDataTarifs] = useState(null); // Données du tarif
  const [dataZone, setDataZone] = useState(null); // Données de la zone
  const [immatriculation, setImmatriculation] = useState(userPlate);
  const [mode, setMode] = useState(MODES.PARENT); // Modes de l'écran (parent/enfant/total)
  const [montantTotal, setMontantTotal] = useState(0); // Montant total des services sélectionnés

  // Modales
  const [messageImmatriculation, setMessageImmatriculation] = useState(false);
  const [modaleAttentePaiementTPEVisible, setModaleAttentePaiementTPEVisible] = useState(false);
  const [modaleChoixPaiementVisible, setModaleChoixPaiementVisible] = useState(false);
  const [modaleImmatriculation, setModaleImmatriculation] = useState(false);
  const [modaleInfosVisible, setModaleInfosVisible] = useState(false);
  const [modalePayzenVisible, setModalePayzenVisible] = useState(false);
  const [preAchatResult, setPreAchatResult] = useState(null); // Résultat du pre-achat (201) pour n'ouvrir la modale qu'en cas de succès
  const [modaleTaxe, setModaleTaxe] = useState(false);
  const [modaleTicketPayzenVisible, setTicketClientModaleVisible] = useState(false);

  // Initialisation des références
  const achatTPEId = useRef(null); // Id de l'achat dans le cadre d'un paiement TPE
  const delaiPayzen = useRef("0"); // Délai pour le ticket payzen
  const devise = useRef(null); // Devise du terminal
  const hasParking = useRef(false) // Définit si il y a un service de stationnement sélectionné
  const hasTax = useRef(false) // Définit si il y a une taxe sur au moins un service
  const initialData = useRef(null); // Données initiales à remettre si l'utilisateur revient en arrière
  const montantTaxe = useRef(0); // Valeur de la taxe de séjour
  const nbPersonne = useRef(0); // Nombre de personnes si taxe séjour par personne
  const serviceTranchesToShow = useRef(null); // Service à utiliser pour afficher les tranches tarifaires
  const typePaiement = useRef(null); // Type de paiement

  // Initialisation des sélecteurs
  // Retours API
  const dataReceivedServices = useSelector((state) => selectDataResourceReceived(state, RESSOURCE_SERVICES)); // Données issues de la requête de zone
  const dataReceivedTarifs = useSelector((state) => selectDataResourceReceived(state, RESSOURCE_TARIFS)); // Données issues de la requête de zone
  const dataReceivedZone = useSelector((state) => selectDataResourceReceived(state, RESSOURCE_ZONE)); // Données issues de la requête de zone
  const dataUpdatedAchats = useSelector((state) => selectDataResourceUpdated(state, RESSOURCE_PRE_ACHATS)); // Données issues de la requête
  const terminalEtatData = useSelector((state) => selectDataResourceReceived(state, RESSOURCE_TERMINAL_ETAT)); // Données de l'état du terminal
  const dataDistributionReceived = useSelector((state) => selectDataResourceReceived(state, RESSOURCE_DISTRIBUTION_UTILISATEUR)); // AYB 2026.01.26 - Récupération de la distribution utilisateur pour détecter les services déjà actifs lors d'un achat normal

  // Initialisation du dispatch
  const dispatch = useDispatch();

  // Traduction i18n
  const { t } = useTranslation();
  // #endregion

  // #region UTILS
  // Renvoie l'icône du bouton de validation
  const getButtonIcon = () => {
    switch (mode) {
      case MODES.PARENT:
        return "shopping_cart"

      case MODES.ENFANT:
      case MODES.TOTAL:
      default:
        return "payment"
    }
  };

  // Renvoie le label dans les boutons de validation / retour
  const getButtonLabel = (isCancel = false) => {
    if (isCancel) {
      return t("achat.cancel");
    }

    let result = t("achat.validation");
    if (hasTax.current) {
      result = t("achat.validationTaxe");
    }

    if (montantTotal) {
      result = result + ` ${(montantTotal ? "(" + Number(montantTotal).toFixed(2) + " €)" : "").trim()}`
    }

    return result;
  };

  // Récupère le montant des taxes
  const getMontantTaxes = () => {
    if (!hasTax || !data) {
      return null;
    }

    let taxe = 0;
    data.forEach(categorie => {
      const serviceTaxe = categorie.services.find(service => service.idServiceType === SERVICES_TYPES.TAXE_SEJOUR && service.selected);

      if (serviceTaxe && serviceTaxe.tarif && serviceTaxe.actualTranche) {
        const serviceParent = categorie.services.find((item) => item.idService === serviceTaxe.serviceParent?.idService);
        if (serviceTaxe.tarif.idUniteType === UNITE_TYPES.PERSONNE_24H && serviceParent) {
          nbPersonne.current = serviceTaxe.quantite;
          taxe = Math.round(((serviceTaxe.quantite * serviceTaxe.actualTranche.prix) * serviceParent.quantite) * 100) / 100;
        }
        if (serviceTaxe.tarif.idUniteType === UNITE_TYPES.EMPLACEMENT_24H) {
          taxe = Math.round(((serviceTaxe.quantite * serviceTaxe.actualTranche.prix)) * 100) / 100;
        }
      }
    });

    // Retourne le montant de la taxe
    montantTaxe.current = taxe;
  };

  // Renvoie la liste des services sélectionnés
  const getServicesSelected = (dateAchat) => {
    let servicesSelected = [];
    const dateCreation = dateAchat;

    data.forEach(categorie => {
      categorie.services.forEach(service => {
        if (service.selected && service.tarif) {
          const totalTranches = getTranches(service);
          totalTranches.forEach(tranche => {
            servicesSelected.push({
              dateCreation: dateCreation,
              devise: service.tarif.devise,
              idService: service.idService,
              idTranche: tranche.idTranche,
              quantite: tranche.quantite,
              notify: 0,
              secondes: service.tarif.secondes,
            })
          })
        }
      });
    });

    return servicesSelected;
  };

  // Initialisation des données
  const initializeData = useCallback(() => {
    if (!dataZone?.length || !dataTarifs?.length || !dataServices?.length) {
      return;
    }

    let services = dataServices;
    let tarifs = dataTarifs;

    services.forEach(service => {
      let tarif = tarifs.find(t => t.idServiceType === service.idServiceType);
      service.tarif = tarif;
      if (tarif) {
        service.actualTranche = getCurrentTranche(tarif, service.quantite || 0);
      }

      if (service.idServiceType === SERVICES_TYPES.PARKING) {
        service.places = dataZone[0].places;
        service.depassement = location.state.depassement;
      }

      service.serviceTypeMaitre = service.serviceParent ? service.serviceParent.idServiceType : service.idServiceType;

      if (isRachat.rachat && isRachat.rachatIdService === service.idService) {
        service.rachat = true;
      }
    });

    // Si le service de rachat est un service enfant, on doit aussi marquer le parent comme rachat
    if (isRachat.rachat) {
      const serviceRachat = services.find(s => s.idService === isRachat.rachatIdService);
      if (serviceRachat && serviceRachat.idServiceParent) {
        const serviceParent = services.find(s => s.idService === serviceRachat.idServiceParent);
        if (serviceParent) {
          serviceParent.rachat = true;
        }
      }
    }

    // Regroupement des services par serviceType
    let groupedData = _.groupBy(services, "serviceTypeMaitre");
    let groupedArray = [];

    Object.keys(groupedData).forEach(key => groupedArray.push({
      id: groupedData[key][0].idServiceType,
      name: groupedData[key][0].serviceType,
      services: groupedData[key]
    }));

    // AYB 2026.01.26 - Récupération des services actifs : priorité aux services passés dans location.state (rachat), sinon utilisation de la distribution récupérée via l'API (achat normal)
    let servicesActifs = [];
    if (location.state?.servicesActifs && Array.isArray(location.state.servicesActifs) && location.state.servicesActifs.length > 0) {
      servicesActifs = location.state.servicesActifs;
    } else if (dataDistributionReceived && Array.isArray(dataDistributionReceived) && dataDistributionReceived.length > 0) {
      servicesActifs = dataDistributionReceived;
    }

    // AYB 2026.01.26 - Transformation automatique en rachat si un service est déjà actif lors d'un achat normal
    let premierServiceRachat = null;
    if (!isRachat.rachat && servicesActifs.length > 0) {
      services.forEach(service => {
        const serviceActif = servicesActifs.find(sa =>
          sa.idService === service.idService &&
          sa.achat &&
          sa.achat.idSite === borne.id
        );
        if (serviceActif) {
          service.rachat = true;
          service.rachatIdService = service.idService;
          if (serviceActif.achat) {
            service.codeAcces = serviceActif.achat.CodeAcces;
            service.dateValidite = serviceActif.dateLimiteValidite;
            service.immatriculation = serviceActif.achat.immatriculation;
            service.depassement = serviceActif.depassement || 0;
            if (!premierServiceRachat) {
              premierServiceRachat = service;
            }
          }
        }
      });

      if (premierServiceRachat) {
        setIsRachat({
          rachat: true,
          rachatIdService: premierServiceRachat.idService
        });
        if (premierServiceRachat.immatriculation) {
          setImmatriculation(premierServiceRachat.immatriculation);
        }
      }
    }

    // En rachat (bouton ou achat avec service actif) : dans la catégorie du rachat, n'afficher que les services actifs
    const enRachat = isRachat.rachat || !!premierServiceRachat;
    const idServiceRachat = isRachat.rachat ? isRachat.rachatIdService : (premierServiceRachat ? premierServiceRachat.idService : null);

    if (enRachat && idServiceRachat) {
      let servicesActifsIds = [];
      if (servicesActifs.length > 0) {
        servicesActifs.forEach((s) => servicesActifsIds.push(s.idService));
      } else {
        // Achat avec service actif : servicesActifs peut ne pas être chargé ; utiliser les services déjà marqués rachat
        services.filter((s) => s.rachat).forEach((s) => servicesActifsIds.push(s.idService));
      }

      const serviceRachat = services.find((s) => s.idService === idServiceRachat);
      if (serviceRachat && serviceRachat.idServiceParent && !servicesActifsIds.includes(serviceRachat.idServiceParent)) {
        servicesActifsIds.push(serviceRachat.idServiceParent);
      }

      let groupeRachat = null;
      groupedArray.forEach((group) => {
        if (group.services.some((s) => s.idService === idServiceRachat)) {
          groupeRachat = group.id;
        }
      });

      groupedArray = groupedArray.map((group) => ({
        ...group,
        services: group.id === groupeRachat
          ? group.services.filter((item) => {
              if (item.idServiceParent) {
                return servicesActifsIds.includes(item.idServiceParent) || servicesActifsIds.includes(item.idService);
              }
              return servicesActifsIds.includes(item.idService);
            })
          : group.services
      })).filter((group) => group.services.length > 0);
    }


    // Mise à jour des données
    setData(_.cloneDeep(groupedArray));
    initialData.current = _.cloneDeep(groupedArray);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataZone, dataServices, dataTarifs, location.state, dataDistributionReceived]);

  // Retourne si une catégorie doit être affiché ou non
  // AYB 2026.02.18 hasServiceSelected : en mode enfant, n'afficher que les enfants du parent sélectionné (pas d'un autre parent actif)
  const isCategorieVisible = (categorie, parent, hasServiceSelectedInData) => {
    let result = true;

    // Si mode enfant et qu'il n'y a pas de parent sélectionné, on cache
    if (mode === MODES.ENFANT && (!parent || parent.idServiceEnfants.length === 0)) {
      result = false;
    }
    // AYB 2026.02.18 si une sélection existe : n'afficher que les catégories dont le parent est sélectionné (pas seulement rachat)
    if (mode === MODES.ENFANT && parent && parent.idServiceEnfants.length > 0 && hasServiceSelectedInData && !parent.selected) {
      result = false;
    }

    // Si mode total et qu'il n'y a pas de service sélectionné, on cache
    if (mode === MODES.TOTAL) {
      result = categorie.services.find(service => service.selected);;
    }

    return result;
  }

  // Sauvegarde de l'achat dans le store
  const storeAchat = useCallback((newAchat, isRachat) => {
    // Sauvegarde de l'idAchat dans le store
    dispatch(setAchat({
      codeAcces: newAchat.CodeAcces,
      // date: maxDate,
      id: newAchat.idAchat,
      idSite: newAchat.idSite,
      immatriculation: newAchat.immatriculation,
      presence: false,
      rachat: isRachat,
      terminalNom: borne.name,
      // decalage: decalage.current ? dateDecalage : null
    }));
  }, [dispatch, borne]);
  // #endregion

  // #region REQUEST
  // Requête de récupération des services
  const requestGetServices = useJsonRequest({
    command: GET,
    getMode: GET_LIST_WITH_PARAMS,
    resource: RESSOURCE_SERVICES,
    url: URL_BASE,
  });

  // Requête de récupération des tarifs
  const requestGetTarifs = useJsonRequest({
    command: GET,
    getMode: GET_LIST_WITH_PARAMS,
    resource: RESSOURCE_TARIFS,
    url: URL_BASE,
  });

  // Requête de récupération des informations du terminal
  const requestGetZone = useJsonRequest({
    command: GET,
    getMode: GET_LIST_WITH_PARAMS,
    resource: RESSOURCE_ZONE,
    url: URL_BASE,
  });

  // Requête de création d'un achat
  const requestPostAchat = useJsonRequest({
    command: POST,
    resource: RESSOURCE_PRE_ACHATS,
    url: URL_BASE,
  });

  // Requête de vérification de l'état du terminal
  const requestGetTerminalEtat = useJsonRequest({
    command: GET,
    getMode: GET_SINGLE,
    resource: RESSOURCE_TERMINAL_ETAT,
    silent: true,
    url: URL_BASE,
  });

  // AYB 2026.01.26 - Requête pour récupérer les services actifs de l'utilisateur (utilisée pour détecter les doublons lors d'un achat normal)
  const requestGetDistributionUtilisateur = useJsonRequest({
    command: GET,
    getMode: GET_LIST,
    resource: RESSOURCE_DISTRIBUTION_UTILISATEUR,
    url: URL_BASE,
  });

  const getBaseAchatPayload = (typePaiement = "Payzen") => {
    let codeAccesRachat = location.state.codeAcces ?? null;
    let dateValiditeRachat = location.state.dateValidite;
    let immatriculationRachat = userPlate || immatriculation;

    if (isRachat.rachat) {
      const serviceRachat = data?.flatMap(categorie => categorie.services.filter(s => s.selected && s.rachat))[0];
      if (serviceRachat) {
        codeAccesRachat = serviceRachat.codeAcces || codeAccesRachat;
        dateValiditeRachat = serviceRachat.dateValidite || dateValiditeRachat;
        immatriculationRachat = serviceRachat.immatriculation || immatriculationRachat;
      }
    }

    const now = moment().format();
    const dateAchat = now;
    // Rachat : dateCreation dérivée de l'achat initial (dateValidite = fin de validité)
    const dateCreation = dateValiditeRachat ? moment(dateValiditeRachat).format() : dateAchat;
    return {
      adresseMail: userEmail ?? null,
      CodeAcces: codeAccesRachat,
      dateAchat: dateAchat,
      dateCreation: dateCreation,
      detailAchats: getServicesSelected(dateCreation),
      idSite: borne.id,
      immatriculation: immatriculationRachat,
      modePaiement: (borne.zones[0].paiementProd === 0 ? TYPE_ACHAT.TEST : TYPE_ACHAT.PROD) || TYPE_ACHAT.INCONNU,
      montant: parseFloat(montantTotal.toFixed(2)),
      numeroCarte: null,
      presenceUser: 0,
      typePaiement: typePaiement,
      langue: getNormalizedLanguageCode(i18n.language),
    };
  };

  const doPostAchat = (achat, typePaiement = "Payzen") => {
    let newAchat = getBaseAchatPayload(typePaiement);
    if (typePaiement === "Payzen") {
      newAchat = { ...newAchat, ...achat };
    }
    requestPostAchat(newAchat);
  };

  const doPostPreAchat = useCallback(() => {
    const payload = getBaseAchatPayload("Payzen");
    return createResource(URL_BASE, tokenValue, RESSOURCE_PRE_ACHATS, payload, 15000);
  }, [tokenValue, location.state, isRachat.rachat, data, userPlate, immatriculation, userEmail, borne, montantTotal]);

  // #endregion

  // #region EVENTS
  // Gestion de la modification d'un service
  const handleChange = (categorie, index, haveParking, haveTax) => {
    let d = [...data];
    d[index] = categorie;

    hasParking.current = haveParking;
    hasTax.current = haveTax;

    setData(_.cloneDeep(d));
  };

  // Gestion du retour en arrière
  const handleClickAnnuler = () => {
    // On réinitialise les données
    hasTax.current = false;
    montantTaxe.current = 0;
    setMontantTotal(0);
    setData(_.cloneDeep(initialData.current));


    setMode(MODES.PARENT);
  };

  // Choix du mode de paiement
  const handleClickChoixModePaiement = (type) => {
    // Fermeture de la modale de choix de paiement
    setModaleChoixPaiementVisible(false);

    switch (type) {
      // Choix PAYZEN : pre-achat d'abord, n'ouvrir la modale qu'en cas de 201
      case PAYZEN:
      case PAYZEN_BORNE:
        setModaleChoixPaiementVisible(false);
        doPostPreAchat()
          .then((res) => {
            setPreAchatResult(res);
            setModalePayzenVisible(true);
          })
          .catch((err) => {
            const msg = err?.error && typeof err.error === "string" && err.error.startsWith("TRANSLATION_KEY:")
              ? t(err.error.replace("TRANSLATION_KEY:", ""))
              : (err?.error || t("common.badRequest"));
            showError(msg);
          });
        break;

      // CHOIX TPE
      case PAYZEN_TPE:
        // Post de l'achat
        doPostAchat(null, TPE);
        break;

      default:
        break;
    }
  };

  // Ouverture de la modale d'informations tarifaires
  const handleClickInfosTranches = (service) => {
    serviceTranchesToShow.current = service;

    setModaleInfosVisible(true);
  }

  // Click sur le bouton Payer
  const handleClickPay = (checkImmaticulation) => {
    // Vérification de l'état du terminal avant de procéder au paiement
    requestGetTerminalEtat(borne.id);

    // let isParking = detailsAchat.current.filter(item => item.serviceType === 4 || item.serviceType === 9).length > 0;
    // AYB 2026.02.09 - demande plaque seulement si parking et plaque user non connue
    if (checkImmaticulation && hasParking.current && !userPlate) {
      if (immatriculation) {
        setModaleImmatriculation(true);
      } else {
        setMessageImmatriculation(true);
      }
      return;
    }

    // AYB 2026.02.16 - Empêche l'enregistrement d'un panier vide : achat gratuit uniquement si au moins un service sélectionné
    if (montantTotal === 0) {
      const servicesSelected = getServicesSelected(moment().format());
      if (servicesSelected.length === 0) {
        showError(t("achat.selectService"));
        return;
      }
      doPostAchat(null, "Free");
      return;
    }

    // Choix du mode de paiment en fonction du type de borne
    switch (borne.idModePaiement) {
      case PAYZEN:
      case PAYZEN_BORNE:
        doPostPreAchat()
          .then((res) => {
            setPreAchatResult(res);
            setModalePayzenVisible(true);
          })
          .catch((err) => {
            const msg = err?.error && typeof err.error === "string" && err.error.startsWith("TRANSLATION_KEY:")
              ? t(err.error.replace("TRANSLATION_KEY:", ""))
              : (err?.error || t("common.badRequest"));
            showError(msg);
          });
        break;

      case PAYZEN_TPE:
        setModaleChoixPaiementVisible(true);
        break;

      default:
        break;
    }
  };

  // Gestion du clic de validation de la sélection
  const handleClickValid = () => {
    let newMode = null;
    let doShowServiceEnfants = false;
    let hasServiceSelected = false;
    // AYB 2026.02.18 parent actif (rachat) avec au moins un enfant non taxe : autoriser accès mode enfant sans sélection
    let hasParentActifAvecEnfantNonTaxe = false;
    // AYB 2026.02.18 au moins un parent sélectionné a des enfants (éviter d'afficher les enfants d'un autre parent)
    let hasSelectedParentWithChildren = false;

    // Boucle sur les services
    data.forEach(categorie => {
      // AYB 2026.02.18 parent sélectionné : afficher étape enfant si au moins un enfant. Parent actif (rachat) : seulement si au moins un enfant non taxe
      categorie.services.forEach((item) => {
        if (!item.idServiceParent && (item.selected || item.rachat) && item.idServiceEnfants.length > 0) {
          const hasNonTaxChild = item.idServiceEnfants.some(idEnfant => {
            const child = categorie.services.find(s => s.idService === idEnfant);
            return child && child.idServiceType !== SERVICES_TYPES.TAXE_SEJOUR;
          });
          if (item.selected) {
            doShowServiceEnfants = true;
            hasSelectedParentWithChildren = true;
          } else if (item.rachat && hasNonTaxChild) {
            doShowServiceEnfants = true;
            hasParentActifAvecEnfantNonTaxe = true;
          }
        }
      });

      // Test si au moins un service est sélectionné
      const doServiceSelected = categorie.services.some((item) => item.selected);
      if (doServiceSelected) {
        hasServiceSelected = true;
      }
    });

    // AYB 2026.02.16 - Blocage validation panier vide : au moins un service requis (achat et rachat)
    // AYB 2026.02.18 sauf si parent actif avec enfant(s) non taxe : autoriser passage au mode enfant
    if (!hasServiceSelected && !hasParentActifAvecEnfantNonTaxe) {
      showError(t("achat.selectService"));
      return;
    }

    // On passe au mode suivant
    switch (mode) {
      case MODES.PARENT:
        // AYB 2026.02.18 n'aller en mode enfant que si un parent sélectionné a des enfants, ou passage sans sélection (rachat)
        if (doShowServiceEnfants && (hasSelectedParentWithChildren || !hasServiceSelected)) {
          newMode = MODES.ENFANT;
        } else {
          newMode = MODES.TOTAL;
        }
        break;

      case MODES.ENFANT:
        if (hasTax.current) {
          getMontantTaxes();
          setModaleTaxe(true);
          return;
        }

        // AYB 2026.02.16 - Blocage validation panier vide en mode enfant (achat et rachat)
        // AYB 2026.02.18 pour passer au total : au moins un service sélectionné (ex. un enfant) obligatoire
        if (!hasServiceSelected) {
          showError(t("achat.selectService"));
          return;
        }

        newMode = MODES.TOTAL;
        break;
      default:
        break;
    }

    // Changement de mode
    setMode(newMode);
  };

  // Fermeture de la modale d'attente du paiement TPE
  const handleCloseModaleAttentePaiementTPE = (achat) => {
    // Fermeture de la modale
    setModaleAttentePaiementTPEVisible(false);

    if (!achat) {
      return;
    }

    switch (achat.statusPayzen) {
      case PAID:
        // Sauvegarde de l'achat dans le store
        storeAchat(achat, isRachat.rachat);
        break;

      default:
        // Information à l'utilisateur
        showError(t("achat.error") || "Le paiement n'a pas abouti", { useOverlay: true, title: "Paiement" });
        break;
    }
  };

  const handlePaymentError = (data) => {
    setModalePayzenVisible(false);
    const status = data?.transactionStatusPayzen;
    const messageKey = status ? `achat.error${status.charAt(0) + status.slice(1).toLowerCase()}` : null;
    const message = (messageKey && t(messageKey)) ? t(messageKey) : (t("achat.error") || "Le paiement n'a pas abouti");
    showError(message, { useOverlay: true, title: "Paiement" });
  };

  const handlePaymentSuccess = (data) => {
    setModalePayzenVisible(false);
    const achatForTicket = data?.achat ?? data;
    if (achatForTicket) {
      setCurrentAchat(achatForTicket);
      setTicketClientModaleVisible(true);
    }
  };

  // AYB 2026.02.19 polling 3 GET id achat à la fermeture modale pour récupérer un éventuel statut mis à jour par l'IPN Payzen
  const pollAchatStatusOnClose = useCallback((idAchat) => {
    let attempt = 0;
    const maxAttempts = 3;
    const delayMs = 2000;
    const tryFetch = () => {
      getResource(URL_BASE, tokenValue, RESSOURCE_PRE_ACHATS, idAchat)
        .then((data) => {
          const status = data?.transactionStatusPayzen;
          if (PAYZEN_VALID_STATUS.includes(status)) {
            handlePaymentSuccess(data);
            return;
          }
          if (status && PAYZEN_REFUSED_STATUSES.includes(status)) {
            handlePaymentError(data ?? null);
            return;
          }
          if (attempt < maxAttempts - 1) {
            attempt += 1;
            setTimeout(tryFetch, delayMs);
          }
        })
        .catch(() => {
          if (attempt < maxAttempts - 1) {
            attempt += 1;
            setTimeout(tryFetch, delayMs);
          }
        });
    };
    tryFetch();
  }, [tokenValue]);

  // AYB 2026.02.19 fermeture modale Payzen : traitement existant + nettoyage sessionStorage puis 3 GET id achat si un paiement était en attente
  const handleCloseModalePayzen = useCallback(() => {
    const pending = sessionStorage.getItem(PENDING_ACHAT_KEY);
    try {
      sessionStorage.removeItem(PENDING_ACHAT_KEY);
      sessionStorage.removeItem(PENDING_STAGE_KEY);
    } catch (_) {}
    setModalePayzenVisible(false);
    setPreAchatResult(null);
    if (pending) {
      pollAchatStatusOnClose(pending);
    }
  }, [pollAchatStatusOnClose]);

  // #endregion

  // #region HOOK D'EFFET
  // Gestion du bouton back du header
  useEffect(() => {
    dispatch(setBackVisible(true));

    return () => dispatch(setBackVisible(false));
  }, [dispatch]);

  // Lancement des requêtes pour récupérer les données
  useEffect(() => {
    if (!borne || !token) {
      return;
    }

    let params = [`idSite=${borne.id}`];
    requestGetServices(params);
    requestGetTarifs(params);

    let zoneParams = [`idTerminal=${borne.id}`];
    requestGetZone(zoneParams);
  }, [borne, token, requestGetServices, requestGetTarifs, requestGetZone]);

  // AYB 2026.01.26 - Récupération automatique de la distribution utilisateur au chargement si pas déjà fournie (pour détecter les services actifs lors d'un achat normal)
  useEffect(() => {
    if (isRachat.rachat) {
      return;
    }
    const servicesActifs = location.state?.servicesActifs || [];
    if (servicesActifs.length === 0) {
      requestGetDistributionUtilisateur();
    }
  }, [isRachat.rachat, location.state, requestGetDistributionUtilisateur]);

  // Récupération des services
  useEffect(() => {
    if (!dataReceivedServices) {
      return;
    }

    let d = [...dataReceivedServices];

    d.forEach(service => {
      let serviceType = serviceTypes.data.find(type => type.idServiceType === service.idServiceType);
      service["serviceType"] = serviceType.libelle;
    });
    setDataServices(d);

  }, [dataReceivedServices, serviceTypes.data]);

  // Récupération des tarifs
  useEffect(() => {
    if (!dataReceivedTarifs) {
      return;
    }

    let d = [...dataReceivedTarifs];

    // Récupération du libellé de l'unité type
    d.forEach(tarif => {
      // Enregistrement de la devise du terminal
      devise.current = tarif.devise;
      let uniteType = uniteTypes.data.find(type => type.idUniteType === tarif.idUniteType);
      tarif["libelleType"] = uniteType.libelleType;
      tarif["secondes"] = uniteType.quantite;
    });

    setDataTarifs(d);
  }, [dataReceivedTarifs, uniteTypes.data]);

  // Récupération des informations sur la zone
  useEffect(() => {
    if (!dataReceivedZone) {
      return;
    }

    let d = [...dataReceivedZone];

    // Calcul du nombre de place disponibles
    const places = d[0].nbPlace - d[0].placeOccupe;
    d.map((item) => { return item.places = places });

    delaiPayzen.current = d[0].delaiPayzen;

    setDataZone(d);
  }, [dataReceivedZone]);

  // Initialisation des données
  useEffect(() => {
    if (!dataZone || !dataTarifs || !dataServices) {
      return;
    }

    initializeData();
  }, [dataZone, dataServices, dataTarifs, initializeData]);

  // Mise à jour du montant total
  useEffect(() => {
    if (!data) {
      return;
    }

    // Boucle dans les catégories + services incrémenter le montant
    const calculMontantTotal = () => {
      let total = 0;

      // Boucle
      data.forEach(categorie => {
        categorie.services.forEach(service => {
          // Si pas de montant on sort
          if (!service.montant) {
            return;
          }

          // Incrémentation du total
          total = total + service.montant;
        });

        // Si taxe séjour à la personne, on applique le montant de la taxe séjour ici
        const hasTaxPersonne = categorie.services.find(item => item.tarif?.idUniteType === UNITE_TYPES.PERSONNE_24H);
        if (hasTaxPersonne) {
          total = total + montantTaxe.current;
        }
      });

      // Mise à jour des données
      setMontantTotal(parseFloat(total.toFixed(2)));
    };

    calculMontantTotal();
  }, [data]);

  // Réception de la confirmation de la création de l'achat
  useEffect(() => {
    if (!dataUpdatedAchats) {
      return;
    }

    // Gestion du retour d'un achat TPE en attente
    if (dataUpdatedAchats.typePaiement === TPE) {
      // Enregistrement des informations necessaires à la création du ticket client
      typePaiement.current = dataUpdatedAchats.typePaiement;
      achatTPEId.current = dataUpdatedAchats.idAchat;

      // Ouverture de la modale d'attente du paiement
      setModaleAttentePaiementTPEVisible(true);
      return;
    }

    // Gestion du retour d'un achat Payzen valide
    if (dataUpdatedAchats.statusPayzen && dataUpdatedAchats.statusPayzen !== PAID) {
      return;
    }

    // Mise à jour de l'achat
    setCurrentAchat(dataUpdatedAchats)

    // Ouverture de la modale du ticket
    setTicketClientModaleVisible(true);
  }, [storeAchat, dataUpdatedAchats]);

  // Gestion de la réponse de vérification de l'état du terminal
  useEffect(() => {
    if (!terminalEtatData) {
      return;
    }

    const TERMINAL_DISPONIBLE = 1;

    // Si le terminal est indisponible ou déconnecté
    if (terminalEtatData.etatTerminal !== TERMINAL_DISPONIBLE) {
      showError(t("achat.terminalDisconnected"));
      history.push("/");
      return;
    }
  }, [terminalEtatData, t, history]);
  // #endregion

  // #region INTERFACE
  return (
    <div className="Achat-Container">
      <div className="Achat-TitleContainer">
        {`${t("achat.borne")} ${borne.name}`}
      </div>
      <div className="Achat-ScrollbarContainer">
        <List >
            {/* Description */}
            {dataZone
              ? <DescriptifBorne data={dataZone[0]} idSite={borne.id} />
              : null
            }
            {/* AYB 2026.02.09 - champ plaque affiché seulement si parking et plaque user non connue */}
            {mode === MODES.TOTAL && hasParking.current && !userPlate ?
              <div className="Achat-TextField">
                <TextField
                  label={t("achat.immatriculation")}
                  name="immatriculation"
                  onChange={(e) => setImmatriculation(e.target.value)}
                  outlined
                  required
                  value={immatriculation}
                />
              </div>
              :
              null
            }

            {/* Liste des catégories */}
            {data && data.map((categorie, index) => {
              const serviceParentSelected = categorie.services.find((item) => { return !item.idServiceParent && (item.selected || item.rachat) });
              const hasServiceSelectedInData = data.some(cat => cat.services.some(s => s.selected));
              return isCategorieVisible(categorie, serviceParentSelected, hasServiceSelectedInData) ? (
                <div key={index} >
                  <AchatList
                    categorie={categorie}
                    categorieIndex={index}
                    mode={mode}
                    onChange={handleChange}
                    openInfosTranches={handleClickInfosTranches}
                    parentSelected={serviceParentSelected}
                    setMode={setMode}
                  />
                </div>
              )
                :
                null
            })}
          </List>
      </div>
      <div className="Achat-ButtonContainer">
        {/* Retour arrière */}
        {mode !== MODES.PARENT
          ?
          <Fab
            icon="undo"
            label={t("achat.cancel")}
            onClick={handleClickAnnuler}
            style={{ marginRight: "10px", paddingLeft: "10px", paddingRight: "10px" }}
          />
          :
          null
        }
        {/* Valider */}
        <Fab
          icon={(borne.idModePaiement === 1 || borne.idModePaiement === 5) ? "close" : getButtonIcon()}
          label={(borne.idModePaiement === 1 || borne.idModePaiement === 5) ? t("achat.paiementSurPlace") : getButtonLabel()}
          onClick={() => { mode === MODES.TOTAL ? handleClickPay(true) : handleClickValid() }}
          disabled={borne.idModePaiement === 1 || borne.idModePaiement === 5}
          style={(borne.idModePaiement === 1 || borne.idModePaiement === 5)
            ? { paddingLeft: "12px", paddingRight: "10px", boxShadow: "-0px 0px 0px -0px rgba(0, 0, 0, 0.5), 0px 0px 0px 0px rgba(0, 0, 0, 0.14), 0px 0px 0px 0px rgba(0, 0, 0, 0.12)", backgroundColor: "black" }
            : { paddingLeft: "12px", paddingRight: "10px" }
          }
        />
      </div>

      {/* Modales */}
      <ConfirmModal
        children={t("achat.confirmMessage")}
        height={"250px"}
        immatriculation={immatriculation}
        onClose={() => setModaleImmatriculation(false)}
        onValid={() => [setModaleImmatriculation(false), handleClickPay(false)]}
        title={t("achat.confirmTitle")}
        visible={modaleImmatriculation}
      />
      <ConfirmModal
        children={t("achat.confirmMessageTaxe")}
        height={"250px"}
        immatriculation={`${t("achat.taxeSejour") + " : " + Number(montantTaxe.current).toFixed(2) + " €"}`}
        info={(nbPersonne.current > 0) ? nbPersonne.current + " " + t("achat.personne") : " "}
        onClose={() => setModaleTaxe(false)}
        onValid={() => [setModaleTaxe(false), setMode(MODES.TOTAL)]}
        title={t("achat.confirmTitleTaxe")}
        visible={modaleTaxe}
      />
      <Snackbar
        open={messageImmatriculation}
        onClose={() => setMessageImmatriculation(false)}
        message={t("achat.needImmatriculation")}
        dismissesOnAction
        action={
          <SnackbarAction
            label={t("achat.hideMessage")}
            onClick={() => setMessageImmatriculation(false)}
          />
        }
      />

      {devise.current && modalePayzenVisible
        ?
        <Modale
          closeOnClickAway={false}
          onClose={handleCloseModalePayzen}
          title={t("achat.bankInfos")}
          visible
          width="350px"
        >
          <PaymentForm
            borne={borne}
            delaiPayzen={delaiPayzen.current}
            devise={devise.current}
            immatriculation={immatriculation}
            montant={Math.round(montantTotal * 100)}
            onBeforeSubmit={doPostPreAchat}
            onErrorPaid={(achat) => { handlePaymentError(achat) }}
            preAchatResult={preAchatResult}
            onSuccessPaid={(achat) => { handlePaymentSuccess(achat) }}
          />
        </Modale>
        :
        null
      }
      <ModaleTypePaiement
        onClick={handleClickChoixModePaiement}
        onClose={() => setModaleChoixPaiementVisible(false)}
        visible={modaleChoixPaiementVisible}
      />

      <TicketClientModale
        achat={currentAchat}
        borne={borne}
        idAchatTPE={achatTPEId.current}
        onClose={() => { setTicketClientModaleVisible(false) }}
        typePaiement={currentAchat ? currentAchat.typePaiement : null}
        visible={modaleTicketPayzenVisible}
      />
      <ModaleAttentePaiementTPE
        idAchat={achatTPEId.current}
        onClose={handleCloseModaleAttentePaiementTPE}
        visible={modaleAttentePaiementTPEVisible}
      />
      <ModaleInfosTranches
        onClose={() => setModaleInfosVisible(false)}
        service={serviceTranchesToShow.current}
        visible={modaleInfosVisible}
      />
    </div>
  );
  // #endregion
};
// #endregion

export { Achat };

